module.exports = __webpack_public_path__ + "static/media/pitch.98de38fa.svg";